.customer-lead-step-fields-tab__container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;

  gap: 32px;

  padding: 24px 0 0;
}
